export declare type DateSelectorMode =
    | 'SingleLineSameDay'
    | 'MultilineWithTime'
    | 'SingleLineDuration'
    | 'MultilineDuration'
    | 'Multiline'
    | 'MultilineWithTimeZones'
    | 'SingleLineAllDay';

export const SINGLE_LINE_SAME_DAY: DateSelectorMode = 'SingleLineSameDay';
export const SINGLE_LINE_ALL_DAY: DateSelectorMode = 'SingleLineAllDay';
export const MULTILINE_WITH_TIME: DateSelectorMode = 'MultilineWithTime';
export const SINGLE_LINE_DURATION: DateSelectorMode = 'SingleLineDuration';
export const MULTILINE_DURATION: DateSelectorMode = 'MultilineDuration';
export const MULTILINE: DateSelectorMode = 'Multiline';
export const MULTILINE_WITH_TIMEZONES: DateSelectorMode = 'MultilineWithTimeZones';

export default DateSelectorMode;
